import React, { CSSProperties, forwardRef } from 'react'
import { hapticEffects } from '@aytm/app/swidget/base/lib/hapticEffects'
import style from './SpinButton.module.scss'

interface ISpinButtonProps {
  styles?: CSSProperties
  value: number
  index: string
  limit?: number
  onClick: (qnt: 1 | -1, index: string) => void
  onSpin: (event: React.KeyboardEvent, index: string) => void
}

const SpinButton = forwardRef<HTMLDivElement, ISpinButtonProps>((props, ref) => {
  const { styles, value, index, onClick, onSpin, limit } = props
  return (
    <div className={style.items} style={styles}>
      <div
        className={`${style.Actions} ${1 === value ? style.itemsDelete : style.itemsMinus}`}
        onClick={() => {
          hapticEffects.selection()
          onClick(-1, index)
        }}
      >
        <span></span>
      </div>
      <div
        ref={ref}
        aria-label={'Add to cart'}
        tabIndex={0}
        role="spinbutton"
        aria-valuenow={value}
        aria-valuemin={1}
        className={style.itemsAmount}
        onKeyDown={event => {
          hapticEffects.selection()
          onSpin(event, index)
        }}
      >
        {value}
      </div>
      <div
        className={`${style.Actions} ${style.itemsPlus} ${limit && value >= limit ? style.disabled : ''}`}
        onClick={() => {
          hapticEffects.selection()
          onClick(1, index)
        }}
      >
        <span></span>
      </div>
    </div>
  )
})

SpinButton.displayName = 'SpinButton'

export default SpinButton
